import { render, staticRenderFns } from "./IndexCert.vue?vue&type=template&id=d8996ef8&scoped=true&"
import script from "./IndexCert.vue?vue&type=script&lang=js&"
export * from "./IndexCert.vue?vue&type=script&lang=js&"
import style0 from "./IndexCert.vue?vue&type=style&index=0&id=d8996ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8996ef8",
  null
  
)

export default component.exports